"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var provider_1 = require("../provider");
var RotaProvider = (function (_super) {
    __extends(RotaProvider, _super);
    function RotaProvider(options) {
        if (options === void 0) { options = {}; }
        _super.call(this, options);
        this.authUrl = options.authUrl;
        this.defaults = {
            responseType: 'id_token code'
        };
        if (!options.appScope || options.appScope.length <= 0) {
            throw new Error("A " + this.name + " app scope must exist");
        }
    }
    RotaProvider.prototype.optionsToDialogUrl = function (options) {
        var url = _super.prototype.optionsToDialogUrl.call(this, options);
        if (options.authType) {
            url += "&auth_type=" + options.authType;
        }
        return url;
    };
    return RotaProvider;
}(provider_1.OAuthProvider));
exports.RotaProvider = RotaProvider;
